<template>
    <div class="layout-nothing">
        <slot />
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.layout-nothing {
}
</style>
